import React from 'react'

const SettingsHeader = ({page, subpage, setActivePage, activePage, description, secondName}) => {
  return (
    <div className='settings-header'>
        <div className='pathname'>
            <span>Workspace Settings</span>
            <span className='mx-2'>/</span>
            <span onClick={() => {setActivePage ? setActivePage(activePage) : null}}>{page}</span>
            {
                subpage &&
                <>
                <span className='mx-2'>/</span>
                <span>
                    {subpage}
                </span>
                </>
            }
        </div>
            
                <div className='settings-page-heading'>
                    {subpage ?? secondName ?? page}
                </div>
        
        <div className='settings-page-description '>
            {description}
        </div>
    </div>
  )
}

export default SettingsHeader